<template>
    <div class="basic_wrap">
        <div class="top_nav">
            <div class="back_icon" @click="$router.push('/user')">
                <van-icon name="arrow-left" />
            </div>
            <div class="nav_title">{{data.payment ? data.payment.name : ''}}</div>
        </div>

        <div class="main_content" v-if="data.payment">
            <div class="m-card qr_card">
                <div class="amount_display">
                    <span class="amount_unit">{{$t('utils.moneyMark')}}</span>
                    <span class="amount_val">{{money}}</span>
                    <div class="actual_amount">{{actualAmount}}</div>
                </div>
                
                <div class="qr_title" v-if="data.payment.type==1">{{$t('invest_qrcode.scanQRcode')}}</div>
                
                <div class="qrcode_img">
                    <img class="qrcode" :src="data.payment.qrcode" alt="" />
                </div>
                
                <div v-if="data.payment.type==1">
                    <div class="wallet_title">{{$t('invest_qrcode.walletAddress')}}</div>
                    <div class="wallet_address">{{data.payment.address}}</div>
                    
                    <div class="copy_btn" @click="copyAddress" v-clipboard="() => data.payment.address" v-clipboard:success="copy">
                        <van-icon name="description" class="copy_icon" />
                        {{$t('invest_qrcode.copyWalletAddress')}}
                    </div>
                </div>
            </div>

            <div class="submit_btn" @click="submitBtn">
                {{$t('utils.submit')}}
            </div>
        </div>
    </div>
</template>

<script>
	import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue'
	import Clipboard from 'v-clipboard';
	Vue.use(Clipboard);
    export default {
        name: "invest_qrcode",
        data() {
            return {
                data: {},
                money: 0,
				actualAmount:'',
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.money = this.$route.query.money;
            this.start();
        },
        methods: {
            start() {
            	Fetch('/user/recharge_type', {
            		money: this.$route.query.money ? this.$route.query.money : "",
					id:this.$route.query.id ? this.$route.query.id : ""
            	}).then((r) => {
            		this.data = r.data;
					this.changeAmount();
            	});
            },
            submitBtn(){
				Fetch("/user/recharge_apply", {
                                        payment_id: this.$route.query.id ? this.$route.query.id : "",
                                        money: this.money
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				});
			},
			copyAddress() {
			    this.mask_show = true;
			    var that = this;
			    var local = window.location.origin;
			    var url = local + this.data.down_image;
			},
			copy() {
				this.$toast({
					className:"toastName",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			changeAmount() {
				var num = 2;
				if (this.data.payment.type == 1) {
					if (this.data.payment.rate > 10000) {
						num = 8;
					} else if (this.data.payment.rate > 1000) {
						num = 6;
					} else if (this.data.payment.rate > 10) {
						num = 4;
					}
					this.actualAmount = "(≈" + (this.money / this.data.payment.rate).toFixed(num) + this.data.payment.mark+")";
				} else {
					this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num)+")";
				}
			}
        }
    };
</script>

<style lang="less" scoped>
    .basic_wrap {
        background-color: #F1F4F6;
        min-height: 100vh;
        padding-bottom: 20px;
    }

    .top_nav {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 46px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        
        .back_icon {
            position: absolute;
            left: 0;
            top: 0;
            height: 46px;
            width: 46px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            color: #333;
            cursor: pointer;
            z-index: 1000;
        }
        
        .nav_title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
    }

    .main_content {
        padding: 61px 15px 15px;
    }

    .m-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);
        padding: 20px;
        margin-bottom: 15px;
    }

    .qr_card {
        text-align: center;
        
        .amount_display {
            margin-bottom: 20px;
            
            .amount_val {
                font-size: 32px;
                font-weight: bold;
                color: #4F46E5;
            }
            
            .amount_unit {
                font-size: 20px;
                color: #4F46E5;
                margin-right: 4px;
            }

            .actual_amount {
                font-size: 14px;
                color: #999;
                margin-top: 4px;
            }
        }

        .qr_title {
            font-size: 14px;
            color: #666;
            margin-bottom: 15px;
        }

        .qrcode_img {
            width: 180px;
            height: 180px;
            margin: 0 auto 20px;
            padding: 10px;
            border: 1px solid #eee;
            border-radius: 8px;
            background: #fff;
            
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .wallet_title {
            font-size: 14px;
            color: #666;
            margin-bottom: 8px;
        }

        .wallet_address {
            font-size: 13px;
            color: #333;
            background: #f8f9fa;
            padding: 12px;
            border-radius: 8px;
            word-break: break-all;
            margin-bottom: 15px;
            line-height: 1.5;
        }

        .copy_btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 8px 20px;
            background: #eef2ff;
            color: #4F46E5;
            border-radius: 20px;
            font-size: 13px;
            font-weight: bold;
            cursor: pointer;
            
            .copy_icon {
                margin-right: 6px;
                font-size: 16px;
            }
            
            &:active {
                opacity: 0.8;
            }
        }
    }

    .submit_btn {
        margin-top: 20px;
        width: 100%;
        height: 48px;
        background: #4F46E5;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3);
        cursor: pointer;
        
        &:active {
            opacity: 0.9;
        }
    }
</style>
